// extracted by mini-css-extract-plugin
export var animationContainer = "_if-0";
export var asteriskIcon = "_if-8";
export var conversationLeftSection = "_if-4";
export var conversationListItem = "_if-3";
export var conversationMiddleSection = "_if-5";
export var conversationRightSection = "_if-6";
export var detailsContent = "_if-1";
export var listContainer = "_if-7";
export var modalContent = "_if-2";